<template>
      <div class="post out">
          <img class="avatar" alt="" />
          <div class="message">
              <span class="arrow"></span>
              <a href="#" class="name">{{message.admin.name}}</a>
              <span class="datetime">{{message.created_at}}</span>
              <span class="body">{{message.message}}</span>
          </div>
      </div>
</template>

<script>
export default {
  props:['message']
}
</script>
